import { useUserSessionStore } from '~/store/user-session'

export default defineNuxtRouteMiddleware((to, _from) => {
  if (import.meta.client) {
    const userSessionStore = useUserSessionStore()

    if (to.path === '/2fa') {
      if (userSessionStore.twoFactorEnabled === true) {
        // external: true is used here to force the layout to fully reload,
        // otherwise there are ssr hydration issues that prevent the page from rendering correctly
        return navigateTo('/', {
          external: true,
        })
      }
    } else if (
      to.path !== '/signin' &&
      to.path !== '/2fa' &&
      to.path !== '/auth/one-time-token' &&
      to.path !== '/auth/reset-password-request' &&
      to.path !== '/auth/reset-password'
    ) {
      if (!userSessionStore.twoFactorEnabled) {
        // external: true is used here to force the layout to fully reload,
        // otherwise there are ssr hydration issues that prevent the page from rendering correctly
        return navigateTo('/2fa', {
          external: true,
        })
      }
    }
  }
})
